import { observable, action, runInAction, computed } from 'mobx'
import axios from 'axios'
import { StoreExt } from '@utils/reactExt'
import { errors } from '@texts/errors'
import { auth } from '@services/api'

export class AuthStore extends StoreExt<any> {
    @observable id = null
    @observable firstName = null
    @observable lastName = null
    @observable fullName = null
    @observable username = null
    @observable token = null
    @observable error = null
    @observable roles = null

    @action
    login = async params => {
        auth.login(params)
            .then(res => {
                const { id, token, username, first_name, last_name } = res.data.user

                runInAction(() => {
                    this.id = id
                    this.firstName = first_name
                    this.lastName = last_name
                    this.token = token
                    this.username = username
                    this.fullName = first_name && last_name ? `${first_name} ${last_name}` : username
                    this.roles = res.data.roles
                    this.setToken(token)
                })
            })
            .catch(error => {
                const errorMsg = errors[error.response.status]
                runInAction(() => {
                    this.error = errorMsg
                    this.resetUser()
                })
            })
    }

    @action
    logout = () => {
        delete axios.defaults.headers['Authorization']
        this.resetUser()
        localStorage.clear()
        console.debug('LoggedOut')
    }

    @action
    resetUser = () => {
        this.id = null
        this.firstName = null
        this.lastName = null
        this.token = null
        this.username = null
        this.roles = null
        delete axios.defaults.headers['Authorization']
    }

    @action
    checkAuth = async () => {
        if (this.token) {
            this.setToken(this.token)
            await auth
                .validToken()
                .then(res => {
                    console.debug('Token is valid')
                })
                .catch(e => {
                    console.debug('Invalid Token')
                    this.logout()
                })
        } else {
            this.resetError()
            this.resetUser()
        }
    }

    @action
    updateRoles = async () => {
        let roles = (await auth.getUserRoles()).data.map(role => role.slug)
        runInAction(() => (this.roles = roles))
    }

    resetError = () => (this.error = null)

    setToken = token => {
        axios.defaults.headers['Authorization'] = `Bearer ${token || this.token}`
    }
}

export default new AuthStore()
